import React, { ReactNode } from 'react'
import { Form as AntdForm, Button } from 'antd'
import { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useRef } from 'react'
import Drawer, { DrawerRef, DrawerProps } from '../drawer'
import { CommonExtendFormProps } from './form'
import Form, { FormProps, FormType } from '.'
import { useToggle } from 'ahooks'

export type DrawerFormRef = Partial<FormType & DrawerRef>
export interface DrawerFormProps extends Partial<CommonExtendFormProps>, Omit<FormProps, 'children'> {
  drawerProps?: Omit<DrawerProps, 'trigger'>
  submitPath?: string,
  submitMethod?: 'POST' | 'PUT' | 'PATCH' | 'DELETE',
  buttonType?: "primary" | "default" | "dashed" | "link" | "text",
  buttonText?: string | ReactNode,
  submitSuccess?: (e: any) => void
}

const DrawerForm: ForwardRefRenderFunction<DrawerFormRef, DrawerFormProps> = (
  {
    title,
    drawerProps,
    onSubmit,
    onVisibleChange,
    okText = '确认',
    cancelText = '取消',
    submitPath,
    submitMethod,
    buttonType = 'primary',
    buttonText = '确认',
    submitSuccess,
    ...formProps
  },
  ref
) => {
  const [currentForm] = AntdForm.useForm()
  const formRef = useRef<FormType>(null)
  const drawerRef = useRef<DrawerRef>(null)
  const form = formProps.form ?? currentForm
  const [open, { toggle }] = useToggle(drawerProps?.open || false)

  useImperativeHandle(
    ref,
    () => ({
      ...(formRef.current || {}),
      ...(drawerRef.current || {}),
    }),
    []
  )

  const handleCancel = () => {
    toggle()
    drawerProps?.onClose?.()
  }

  return (
    <div onClick={(e) => {
      e.stopPropagation()
    }}>
      <Button type={buttonType} onClick={toggle}>
        {buttonText}
      </Button>
      <Drawer
        ref={drawerRef}
        {...drawerProps}
        open={open}
        title={title}
        onClose={handleCancel}
        destroyOnClose
      >
        <Form
          // @ts-ignore
          ref={formRef}
          form={form}
          card={false}
          submitPath={submitPath}
          submitMethod={submitMethod}
          submitSuccess={(e) => {
            submitSuccess?.(e)
            toggle()
          }}
          cancel={() => {
            toggle()
          }}
          {...formProps}
        />
      </Drawer>
    </div>
  )
}

export default forwardRef(DrawerForm)
